import { render, staticRenderFns } from "./scrollbar.html?vue&type=template&id=1f95c7d2&scoped=true&"
import script from "./scrollbar.js?vue&type=script&lang=js&"
export * from "./scrollbar.js?vue&type=script&lang=js&"
import style0 from "./scrollbar.scss?vue&type=style&index=0&id=1f95c7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f95c7d2",
  null
  
)

export default component.exports